export default __webpack_public_path__ + "static/media/33t.a2f73f0c.jpg";